import IntercomCFCore from './IntercomCFCore';

class IntercomCF extends IntercomCFCore {
  static updateSubscriptionData = async (
    userId: string, subscriptionStatus: string,
  ): Promise<any> => IntercomCFCore.coreUpdateSubscriptionData(userId, subscriptionStatus)
}

export default IntercomCF;
